import { IStateDispatchActions } from '../TeeSheetCreator.context';
import { IOnSelectPlayerToSwap } from './onSelectPlayerToSwap';

interface IOnPlayerSwapAugmentedArgs {
  onSelectPlayerToSwapAugmented: IOnSelectPlayerToSwap;
}

export type IOnPlayerSwap = (enrollmentId: number) => () => Promise<any>;

type IOnPlayerSwapAugmented = (args: IOnPlayerSwapAugmentedArgs) => IOnPlayerSwap;

export const onPlayerSwap: IStateDispatchActions<IOnPlayerSwapAugmented> = (
  state,
  dispatch
) => args => (enrollmentId: number) => async () => {
  const { selectedPlayer } = state;
  const { onSelectPlayerToSwapAugmented: onSelectPlayerToSwap } = args;

  if (selectedPlayer === enrollmentId) {
    dispatch({ type: 'set', value: { attribute: 'selectedPlayer', value: 0 } });
    return;
  }

  if (selectedPlayer === 0) {
    dispatch({ type: 'set', value: { attribute: 'selectedPlayer', value: enrollmentId } });
  } else {
    await onSelectPlayerToSwap(enrollmentId)();
  }
};
